import React from 'react';
import Step from './Step';
import SummaryUnitTypeSection from './summary/SummaryUnitTypeSection';
import SummaryEESLabelSection from './summary/SummaryEESLabelSection';
import SummaryPricingSection from './summary/SummaryPricingSection';
import SummaryHeatingTWS from './summary/SummaryHeatingTWS';
import SummaryHeatingSection from './summary/SummaryHeatingSection';
import SummaryControllerSection from './summary/SummaryControllerSection';
import SummaryOptionsSection from './summary/SummaryOptionsSection';
import SummaryPrimarySideEquipment from './summary/SummaryPrimarySideEquipmentSection';
import store from '../../../store/configuration';

export default class StepSummary extends Step {

    pricingSectionRef = React.createRef()

    stepAboutToBecomeVisible() {
        if (this.pricingSectionRef.current) {
            this.pricingSectionRef.current.stepAboutToBecomeVisible()
        }
    }

    renderBody() {
        const renderHeatings = () => {
            let results = []
            for (let i = 1; i <= this.props.model.unitType.heatingSectionCount.value; i++) {
                if (typeof this.props.model['heating' + i] !== 'undefined') {
                    results.push(<SummaryHeatingSection key={i} model={this.props.model}
                                                        heatingModel={this.props.model['heating' + i]} index={i}/>)
                }
            }
            return results
        }

        const renderDHW = () => {
            if (typeof this.props.model.dhw !== 'undefined') {
                return <SummaryHeatingSection model={this.props.model} heatingModel={this.props.model.dhw}
                                              isDHW={true}/>
            }

            return <React.Fragment></React.Fragment>;
        }

        return (
            <React.Fragment>
                <div className="configuration-editor-summary-unit-code">
                    <span>{__('Model')}</span>
                    <span>{this.props.model.summary.modelName.value}</span>
                </div>

                <SummaryUnitTypeSection model={this.props.model}/>
                {this.props.model.heatingTWS && <SummaryHeatingTWS heatingModel={this.props.model.heatingTWS}/>}
                {renderHeatings()}
                {renderDHW()}
                <SummaryControllerSection model={this.props.model}/>
                <SummaryPrimarySideEquipment model={this.props.model}/>
                <SummaryOptionsSection model={this.props.model}/>
                {store.getEESLevel() && <SummaryEESLabelSection model={this.props.model}/>}

                {(store.isStepAvailable('pricing') || store.isStepAvailable('topArticleNumberPricing')) && (
                    <SummaryPricingSection model={this.props.model} ref={this.pricingSectionRef}/>
                )}
            </React.Fragment>
        )
    }
}
